import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { colors } from '../../styles/colors'

const Container = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .link {
        font-family: 'SF UI Text', sans-serif;
        font-size: 3rem;
        color: ${colors.dark_blue};
        white-space: nowrap;
        text-decoration: none;
    
        padding-bottom: .5rem;
        margin-right: 1rem;
        border-bottom: 1px solid ${colors.dark_blue};
    
        transition: all .25s;
    
        :hover {
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }

        @media (max-width: 320px) {
            font-size: 2.25rem;
        }
    }
`

export const LinkButton = ({link, text}) => {
    return (
        <Container className='link-button' onClick={ () => window.scrollTo(0, 0) }>
            <Link className='link' to={link}> {text} </Link>
            <svg width="31" height="12" viewBox="0 0 31 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.5303 6.53033C30.8232 6.23744 30.8232 5.76256 30.5303 5.46967L25.7574 0.696699C25.4645 0.403806 24.9896 0.403806 24.6967 0.696699C24.4038 0.989593 24.4038 1.46447 24.6967 1.75736L28.9393 6L24.6967 10.2426C24.4038 10.5355 24.4038 11.0104 24.6967 11.3033C24.9896 11.5962 25.4645 11.5962 25.7574 11.3033L30.5303 6.53033ZM0 6.75H30V5.25H0V6.75Z" fill="#00253D" />
            </svg>
        </Container>
    )
}
